import AttachmentsList from 'components/AttachmentsList'
import React from 'react'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayNegativeMedias(props) {
  const { questionData: answerData } = props
  const classes = styles()

  const buildNegativeMedia = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Assunto: </span>
          {activityInfo?.subject}
        </p>
        <p>
          <span>Link da notícia: </span>
          {activityInfo?.media_link}
        </p>
        {activityInfo?.envolvement_resume !== '' ? (
          <p>
            <span>Resumo do envolvimento na notícia: </span>
            {activityInfo.envolvement_resume}
          </p>
        ) : null}
        {activityInfo?.attachments?.length > 0 ? (
          <AttachmentsList attachments={activityInfo?.attachments} />
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das mídias negativas:</h3>
      <DisplayAnswerItems
        answerData={answerData}
        noDataMessage="O assessor informou que não consta em nenhuma mídia negativa."
        funcBuildItem={buildNegativeMedia}
      />
    </div>
  )
}

export default DisplayNegativeMedias
